import { render } from "./BusinessPartnerRequest.vue?vue&type=template&id=5b549b3a&scoped=true"
import script from "./BusinessPartnerRequest.vue?vue&type=script&lang=js"
export * from "./BusinessPartnerRequest.vue?vue&type=script&lang=js"

import "./BusinessPartnerRequest.vue?vue&type=style&index=0&id=5b549b3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b549b3a"]])

export default __exports__